const SLWorker = Mach.requireModule('SLWorker');
let token = 1;

export function callModule(moduleName: string, method: string, callback?: Function, ...args: any[]) {
  if (!!SLWorker && !!SLWorker.callModuleInMainThread) {
    const result = SLWorker?.callModuleInMainThread(moduleName, method, ...args, callback);
    return result;
  } else {
    const Module = Mach.requireModule(moduleName);
    const result = Module[method]?.(...args, callback);
    return result;
  }
}

export const getToken = () => {
  token = (token + 1) % 27;
  return token;
};

export const isSameToken = (curToken) => curToken === token;
export async function resoursesCallback(data = {}): Promise<void> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const url = 'dsp/resouece/show/call_back';
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    data: {
      ...data,
    },
  };
  // @ts-ignore
  // const indicatorModule = Mach.requireModule('ActivityIndicator');
  // indicatorModule.showLoading();
  networkModule.requestWx(params, (result: any) => {
    // indicatorModule.hideLoading();
    const code = result?.data?.code ?? 1;
    if (code === 0) {
      console.log(result.data);
    } else {
      console.log(result.data);
    }
  });
}
const radomUUID = () => {
  const time = new Date().valueOf();
  return `${(Mach.requireModule('SLCommon')?.randomUUID?.() || '')}${time}`;
};
const initData = (activity: any, showState?: number) => {
  const {
    launchTaskId,
    launchTaskName,
    sourceMaterialId,
    sourceMaterialName,
    channelId,
    ...otherData
  } = activity;
  const launchTaskShowState = showState;
  // 后端返回的投放任务数据value有可能返回值为stringify后的string
  // 这里我们需要将stringify后的结构转换为实际的数据结构
  // 传入组件
  const convertedData = {};
  Object.keys(otherData).forEach((d) => {
    const value = otherData[d];
    try {
      convertedData[d] = JSON.parse(value);
    } catch (e) {
      convertedData[d] = value;
    }
  });
  return {
    id: launchTaskId,
    launchTaskName,
    sourceMaterialId,
    sourceMaterialName,
    channelId,
    launchTaskShowState,
    ...convertedData,
  };
};

export const matrixTemplate = (dspData) => {
  const taskData = dspData?.launchTaskList?.map((activity) => initData(activity, dspData?.launchTaskShowState));
  const mainData: any = {
    ...dspData,
    id: dspData?.channelId,
    autoPlay: dspData?.autoPlay,
    carouselTime: dspData?.carouselTime,
    t_matrix_show_type: 'home_popup',
    pageRootId: radomUUID(),
    inputParams: {},
    lxConfig: {
      cid: 'c_waimai_c_overseas_aatucy3n',
      lxParams: {
      },
    },
    data: taskData,
  };
  if (dspData.launchTaskShowState) {
    resoursesCallback({
      channelId: dspData.channelId
    });
  }
  return {
    msg_type: 1,
    msg_id: '1742370412322',
    event_type: 4,
    trigger_time: 1000000000,
    interval_time: 0,
    expire: 0,
    priority: 0,
    conflict_show_time: 3,
    conflict_show_count: 600,
    msg_body: {
      touch_mode: 4, // 展示形式
      biz: 'sailor',
      condition: {
        contain_type: 1,
        page_list: [
          { page_id: 'mach_pro_sailor_c_home_page_main' },
        ]
      },
      business_data: {
        alert_module_list: [
          {
            module_id: '123',
            template_id: 'mach_pro_sailor_mkt_resources_home_pop_main',
            string_data: '',
            data_type: 0,
            json_data: mainData
          }
        ]
      }
    }
  };
};
